<template>
  <div class="assign-personnel">
    <div class="personnel-wrap">
      <div v-for="tag in activeAssignments" :key="tag.uid" class="person-tag">
        <span class="person-no">{{ tag.assignedPersonnel }}</span>
        <span class="step-btn" @click="changeQty(tag, -1)">-</span>
        <span class="qty">{{ tag.assignedQuantity }}</span>
        <span class="step-btn" @click="changeQty(tag, 1)">+</span>
        <a-icon type="close" class="remove-btn" @click="removeAssignment(tag.uid)" />
      </div>
      <a-button v-if="!adding" size="small" @click="showAddForm">新增人员</a-button>
      <div v-else class="add-row">
        <a-select
          v-model="addForm.assignedPersonnel"
          show-search
          allow-clear
          size="small"
          class="employee-select"
          placeholder="编号"
          :filter-option="false"
          @search="loadEmployeeOptions"
        >
          <a-select-option v-for="item in employeeOptions" :key="item.number" :value="item.number">
            {{ item.number }}
          </a-select-option>
        </a-select>
        <a-input-number
          v-model="addForm.assignedQuantity"
          :min="1"
          :precision="0"
          size="small"
          class="qty-input"
        />
        <a-button type="primary" size="small" @click="handleAdd">添加</a-button>
        <a-button size="small" @click="hideAddForm">取消</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { apiMesProcessSchedulingEmployeeList } from '@/api/mes/workOrderManage/ouKangOrderScheduling'

export default {
  name: 'AssignPersonnelCell',
  props: {
    record: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      adding: false,
      employeeOptions: [],
      assignments: [],
      addForm: {
        assignedPersonnel: undefined,
        assignedQuantity: 1
      }
    }
  },
  computed: {
    activeAssignments () {
      return this.assignments.filter(item => !item.deleted)
    },
    planQuantity () {
      const quantity = Number(this.record.planQuantity)
      return Number.isFinite(quantity) ? quantity : 0
    },
    activeAssignedQuantity () {
      return this.getAssignedQuantity()
    }
  },
  created () {
    this.assignments = (this.record.assignmentList || []).map(item => ({
      uid: item.id || `${Date.now()}_${item.assignedPersonnel}`,
      id: item.id,
      assignedPersonnel: item.assignedPersonnel,
      assignedQuantity: item.assignedQuantity || 1,
      deleted: item.deleted === true || item.deleted === 1
    }))
  },
  methods: {
    showAddForm () {
      this.adding = true
      if (!this.employeeOptions.length) {
        this.loadEmployeeOptions()
      }
    },
    hideAddForm () {
      this.adding = false
      this.addForm = {
        assignedPersonnel: undefined,
        assignedQuantity: 1
      }
    },
    async loadEmployeeOptions (keyword) {
      const res = await apiMesProcessSchedulingEmployeeList(keyword)
      this.employeeOptions = res.data || res.rows || []
    },
    getAssignedQuantity (extraQuantity = 0, excludeUid) {
      return this.activeAssignments.reduce((total, item) => {
        if (excludeUid && item.uid === excludeUid) {
          return total
        }
        return total + Number(item.assignedQuantity || 0)
      }, Number(extraQuantity || 0))
    },
    hasDuplicatePersonnel () {
      const personnelSet = new Set()
      return this.activeAssignments.some(item => {
        if (!item.assignedPersonnel) {
          return false
        }
        if (personnelSet.has(item.assignedPersonnel)) {
          return true
        }
        personnelSet.add(item.assignedPersonnel)
        return false
      })
    },
    validateAssignments () {
      const rowName = this.record.subProcessCodeName || '当前行'
      if (this.hasDuplicatePersonnel()) {
        this.$message.warning(`${rowName}分配人员编码不能重复`)
        return false
      }
      if (this.activeAssignedQuantity > this.planQuantity) {
        this.$message.warning(`${rowName}累计分配人员数不能大于计划数量`)
        return false
      }
      return true
    },
    handleAdd () {
      if (!this.addForm.assignedPersonnel) {
        return this.$message.warning('请选择编号')
      }
      if (this.activeAssignments.some(item => item.assignedPersonnel === this.addForm.assignedPersonnel)) {
        return this.$message.warning('该编号已添加')
      }
      if (this.getAssignedQuantity(this.addForm.assignedQuantity) > this.planQuantity) {
        return this.$message.warning('累计分配人员数不能大于计划数量')
      }
      this.assignments = [
        ...this.assignments,
        {
          uid: `new_${Date.now()}_${this.addForm.assignedPersonnel}`,
          id: undefined,
          assignedPersonnel: this.addForm.assignedPersonnel,
          assignedQuantity: this.addForm.assignedQuantity || 1,
          deleted: false
        }
      ]
      this.emitChange()
      this.hideAddForm()
    },
    changeQty (tag, delta) {
      const nextQty = tag.assignedQuantity + delta
      if (nextQty < 1) {
        return
      }
      if (this.getAssignedQuantity(nextQty, tag.uid) > this.planQuantity) {
        return this.$message.warning('累计分配人员数不能大于计划数量')
      }
      this.assignments = this.assignments.map(item =>
        item.uid === tag.uid ? { ...item, assignedQuantity: nextQty } : item
      )
      this.emitChange()
    },
    removeAssignment (uid) {
      this.assignments = this.assignments
        .map(item => {
          if (item.uid !== uid) {
            return item
          }
          return item.id ? { ...item, deleted: true } : null
        })
        .filter(Boolean)
      this.emitChange()
    },
    emitChange () {
      this.$emit('change', this.getAssignmentPayload())
    },
    getAssignmentPayload () {
      return this.assignments.map(item => ({
        id: item.id,
        assignedPersonnel: item.assignedPersonnel,
        assignedQuantity: item.assignedQuantity,
        deleted: !!item.deleted
      }))
    }
  }
}
</script>

<style scoped lang="less">
.assign-personnel {
  min-width: 0;
}

.personnel-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.person-tag {
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  background: #f0f5ff;
  border: 1px solid #d6e4ff;
  border-radius: 4px;
  font-size: 12px;
  line-height: 20px;
}

.person-no {
  color: #1890ff;
  margin-right: 4px;
  white-space: nowrap;
}

.step-btn {
  width: 16px;
  text-align: center;
  cursor: pointer;
  color: #666;
  user-select: none;
  &:hover {
    color: #1890ff;
  }
}

.qty {
  min-width: 16px;
  text-align: center;
  font-weight: 600;
  color: #333;
}

.remove-btn {
  margin-left: 4px;
  font-size: 10px;
  color: #999;
  cursor: pointer;
  &:hover {
    color: #ff4d4f;
  }
}

.add-row {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 4px;
  background: #f5f7fa;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  flex-shrink: 0;
}

.employee-select {
  width: 120px;
}

.qty-input {
  width: 55px;
}
</style>
